export default __webpack_public_path__ + "f8c64b558368890b6fcb8f20d0dc7654.png";